var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_21011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_21011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8391 101.955C43.5487 102.582 17.3944 96.7698 16.0757 78.4747C15.7621 75.1524 16.427 71.8109 17.9887 68.8604C19.5505 65.91 21.9411 63.4792 24.8671 61.8662C24.8671 61.8662 18.7508 74.6565 30.5186 74.6565C42.2865 74.6565 23.4228 54.5933 24.4903 44.8753C25.4448 36.1917 32.7165 33.5898 33.7652 32.7559C34.8138 31.922 30.2298 47.8032 35.8688 47.2578C41.5078 46.7123 51.2537 28.0787 47.5236 15C47.5236 15 62.2931 25.1632 60.1455 50.6497C60.1455 50.6497 58.136 58.6687 62.8645 57.2329C67.593 55.7971 67.0278 48.3612 64.5851 42.1856C64.5851 42.1856 80.9119 50.0603 72.334 68.9573C72.334 68.9573 63.9697 81.3149 69.4141 83.7037C74.8584 86.0925 81.8412 79.8854 80.981 72.6314C80.981 72.6314 97.5212 92.3873 63.4925 100.601C63.4925 100.601 53.0684 90.9578 61.9603 75.064C61.9603 75.064 56.0324 74.7819 53.6901 80.4121C53.6901 80.4121 55.4107 61.0825 52.6854 53.2077C52.6854 53.2077 41.3822 73.7286 46.0919 92.2431C46.0919 92.2431 41.7904 91.8606 41.3132 85.2335C41.3132 85.2523 35.1906 94.9829 42.8391 101.955Z",
    fill: "#E62645"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFire);
export default __webpack_public_path__ + "static/media/imgFire.2d377ce3e0f1a5bc568699c90656855b.svg";
export { ForwardRef as ReactComponent };